export default __webpack_public_path__ + "static/media/logo-uk.e3d37b86.svg";